/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import BulkCopyComponent from '../components/BulkCopyComponent'
import { companyActions } from '../_actions'
import { messageConstants } from '../_constants'
import { Growl } from 'primereact/growl'

function BulkCopyContainer({ bulkUpdateSuccessMessage, bulkUpdatResponse, bulkAddForCopyPaste, clearAllMessages }) {
  console.log(bulkUpdateSuccessMessage)
  const growl = useRef()
  const showActiveCompanyGrowl = (message) => {
    growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: message })
  }
  if (bulkUpdatResponse) {
    if (Object.keys(bulkUpdatResponse['UPDATED']) > 0 || Object.keys(bulkUpdatResponse['SAVED']) > 0) {
      showActiveCompanyGrowl('Data Imported Successfully')
      clearAllMessages()
    }
  }
  return (
    <div className="p-grid pageWrapper">
      <Growl ref={growl} />
      <BulkCopyComponent bulkUpdatResponse={bulkUpdatResponse} bulkAddForCopyPaste={bulkAddForCopyPaste} />
    </div>)
}
const mapStateToProps = state => {
  return {
    bulkUpdateSuccessMessage: state.company.bulkUpdateSuccessMessage,
    bulkUpdatResponse: state.company.bulkUpdatResponse
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    bulkAddForCopyPaste: (companyList, id) => dispatch(companyActions.bulkAddForCopyPaste(companyList, id)),
    clearAllMessages: () => dispatch(companyActions.clearAllMessages())
  }
}
BulkCopyContainer.propTypes = {
  bulkUpdateSuccessMessage: PropTypes.string,
  bulkUpdatResponse: PropTypes.object,
  bulkAddForCopyPaste: PropTypes.func,
  clearAllMessages: PropTypes.func
}
export default connect(mapStateToProps, mapDispatchToProps)(BulkCopyContainer)
